import React from 'react';

import classNames from 'classnames';
import range from 'lodash/range';

import './style.scss';

interface IProps {
  currentStep: number;
  totalSteps: number;
}

const ProgressBar = ({ totalSteps, currentStep }: IProps) => {
  return (
    <div className="OnboardingProgress">
      <div className="progressBar">
        {range(0, totalSteps).map((stepNumber) => (
          <div
            key={stepNumber}
            className={classNames('step', { fill: stepNumber < currentStep })}
            style={{
              width: `${100 / totalSteps}%`,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
